/**
 * Enum for backend submission status
 */
export enum BackendSubmissionStatus {
    ACTIVE,
    FAILED_SCREENING,
    FAILED_REVIEW,
    COMPLETED_WITHOUT_WIN,
    DELETED,
    FAILED_CHECKPOINT_SCREENING,
    FAILED_CHECKPOINT_REVIEW,
    AI_FAILED_REVIEW,
}
